import ButtonStart from '@/components/kiosk/ButtonStart';
import { isFunction } from '@/se/utilities/check';
import enterFullScreen from '@/se/utilities/enter-full-screen';
import { makeStyles } from '@material-ui/core/styles';
import React, { Fragment } from 'react';
import { matchPath, withRouter } from 'react-router-dom';
import { branch, compose, renderComponent } from 'recompose';
import ClientUpdater from '../../ClientUpdater';

const EnterFullScreen = ({ isInFullScreen, onFullScreenEnter }) => {
  const classes = useStyles();

  const handleClick = async () => {
    try {
      await enterFullScreen(document.documentElement);

      if (isFunction(onFullScreenEnter)) {
        onFullScreenEnter();
      }
    } catch (error) {
      console.error(`Can‘t go to full screen`, error.message);
    }
  };

  return (
    <Fragment>
      <div className={classes.root} onClick={handleClick}>
        <ButtonStart>Start</ButtonStart>
      </div>
      <ClientUpdater />
    </Fragment>
  );
};

const useStyles = makeStyles(theme => ({
  root: {
    position: 'fixed',
    display: 'flex',
    zIndex: 9999,
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    backgroundColor: theme.palette.background.default,
    alignItems: 'center',
    justifyContent: 'center',
  },
}));

const isTabletScreen = (match, location) =>
  matchPath(location.pathname, {
    path: `${match.path}/tablet`,
    exact: false,
    strict: false,
  }) ||
  matchPath(location.pathname, {
    path: `${match.path}/nursing`,
    exact: false,
    strict: false,
  }) ||
  matchPath(location.pathname, {
    path: `${match.path}/charting`,
    exact: false,
    strict: false,
  }) ||
  matchPath(location.pathname, {
    path: `${match.path}/waiting-room-tablet`,
    exact: false,
    strict: false,
  });

export default compose(
  withRouter,
  branch(
    ({ isInFullScreen, match, location }) => !isInFullScreen && !isTabletScreen(match, location),
    renderComponent(EnterFullScreen)
  )
)(() => null);
